import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import Dropdown from './../Dropdown'
import check from '../assets/check.png'
import Prompt from '../Prompt'
import TransomConfigurator from './../TransomConfigurator'
import Disclaimer from '../Disclaimer'
import { NavLink } from 'react-router-dom'
import { withTranslation, Trans } from 'react-i18next'
import { view01ImageOptions } from './views/view01'

class X46Hull extends Component {
  constructor (props) {
    super(props)

    this.state = {
      expanded: false,
      code: '',
      promptVisible: false,
      codeBoat: '',
      codePrompVisible: false
    }

    this.handleHullColorChange = this.handleHullColorChange.bind(this)
    this.handleCodeSubmit = this.handleCodeSubmit.bind(this)
  }

  componentWillUnmount () {
    clearTimeout(this.timer)
  }

  handleHullColorChange (newValue) {
    let configuration = this.props.configuration
    configuration.HullColour = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleCodeSubmit () {
    let json = JSON.parse(atob(this.state.code))

    if (json[0] !== 'x46') {
      if (typeof json[0] === 'string') {
        this.setState({
          codeBoat: json[0],
          codePrompVisible: true
        })
      }
      return
    }

    if (this.props.onCodeSubmitted) {
      this.props.onCodeSubmitted(this.state.code)
    }

    this.setState({ promptVisible: true })

    this.timer = setTimeout(() => {
      this.setState({ promptVisible: false })
    }, 5000)
  }

  render () {
    let imageOptions = view01ImageOptions

    let image = (
      <TransomConfigurator
        colorMultiplier={0.75}
        name={this.props.transom.Name}
        port={this.props.transom.Port}
        transomSize={{ width: 2895, height: 780 }}
        transform={[
          0.062357, -0.000963, 0, -2.3e-5, 0.003397, 0.097934, 0, 5.6e-6, 0, 0,
          1, 0, 220.028066, 404.093037, 0, 1
        ]}
      >
        <ConfiguratorImage
          boat='X4_6'
          configuration={this.props.configuration}
          options={imageOptions}
        />
      </TransomConfigurator>
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption style={{ position: 'relative' }}>
          <Prompt type='info' visible={this.state.promptVisible}>
            Configuration loaded
          </Prompt>
          <Prompt type='error' visible={this.state.codePrompVisible}>
            <Trans
              defaults='Code is for {{boat}}'
              values={{ boat: this.state.codeBoat }}
            />{' '}
            <NavLink
              to={'/' + this.state.codeBoat + '?code=' + this.state.code}
            >
              go there
            </NavLink>
          </Prompt>

          <h1>
            <Trans defaults='Hull Colourways' />
          </h1>

          <Dropdown
            options={this.props.hullColourOptions}
            onChange={this.handleHullColorChange}
            value={this.props.configuration.HullColour}
            style={{ maxWidth: 472 }}
          />

          <p>
            <img
              style={{ border: '1px solid #c2c2c2' }}
              src={this.props.configuration.HullColour.preview}
              alt={this.props.configuration.HullColour.label}
            />
          </p>

          <h2>
            <Trans defaults='Hull' />
          </h2>

          <p>
            <Trans defaults='X-Yachts hulls are built using the latest high-tech construction technologies with a vacuum-infused, post-cured (oven baked @ 80 C) EPOXY construction and gelcoat finish.' />
          </p>

          <h2>
            <Trans defaults='Keel structure' />
          </h2>

          <p>
            <Trans defaults='Heat-galvanized steel keel frame improves strength, enables central lift hoist attachment and safety.' />
          </p>

          <h2>
            <Trans defaults='Load previous configuration' />
          </h2>
          <p>
            <Trans defaults='If you have previously been through the configurator, you get the opportunity to get your own personal code, reflecting the selections you have made throughout 16 steps. In the field below, you can load this code enabling you to see your previous configuration.' />
          </p>
          <button
            className='button'
            style={{ marginRight: 15 }}
            onClick={() => {
              this.setState({ expanded: !this.state.expanded })
            }}
          >
            <Trans defaults='Load code' />
          </button>
          <div
            className={'expander' + (this.state.expanded ? ' open' : ' closed')}
          >
            <p>
              <input
                type='text'
                value={this.state.code}
                style={{ width: 262, verticalAlign: 'top', marginRight: 10 }}
                onChange={event => {
                  this.setState({ code: event.target.value })
                }}
              />
              <button
                className='secondary button'
                onClick={this.handleCodeSubmit}
              >
                <img src={check} alt='submit' />
              </button>
            </p>
          </div>
          <Disclaimer />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46Hull)



// WEBPACK FOOTER //
// ./src/X46/X46Hull.js